import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { TUI_DARK_MODE } from '@taiga-ui/core/tokens';
import { TuiLanguageSwitcherService } from '@taiga-ui/i18n';

import { initializeLanguage, mapLanguageToTui } from '@common/utils/lang';
import { syncLegacyDarkTheme } from '@common/utils/theme';
import { AppService } from '@services/app.service';

import { environment } from '../environments/environment';

import { MobileDialogBackService } from './mobile/services/mobile-dialog-back.service';
import { MobileDropdownGhostClickService } from './mobile/services/mobile-dropdown-ghost-click.service';
import { MobileKeyboardService } from './mobile/services/mobile-keyboard.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent implements OnInit {
  protected readonly night = inject(TUI_DARK_MODE);
  private readonly switcher = inject(TuiLanguageSwitcherService);
  private readonly translate = inject(TranslateService);
  private readonly appService = inject(AppService);
  // Мобильные глобальные обработчики: создаются здесь, чтобы работать с первого экрана
  private readonly dialogBack = inject(MobileDialogBackService);
  private readonly dropdownGhostClick = inject(MobileDropdownGhostClickService);
  private readonly keyboard = inject(MobileKeyboardService);

  readonly isLoading = toSignal(this.appService.isLoading, { requireSync: true });

  get mode(): 'onDark' | 'onLight' | null {
    return this.night() ? 'onDark' : null;
  }

  constructor() {
    syncLegacyDarkTheme(this.night);
  }

  ngOnInit(): void {
    const selectedLanguage = initializeLanguage(
      this.translate,
      environment.defaultLocale,
      environment.locales,
    );
    this.switcher.setLanguage(mapLanguageToTui(selectedLanguage));
  }
}
